<template>
  <div class="innerItem">
    <p class="innerTitle setLabel">{{locale.point_color}}</p>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">주요 색상1</span>
        <ColorPicker class="mt5" :target="'primaryColor1'" :color="pointcolors.primaryColor1" :pointcolors="true" />
      </div>
      <div class="flexInner"></div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">컨텐츠 {{locale.background}}</span>
        <ColorPicker class="mt5" :target="'contentsBg'" :color="pointcolors.contentsBg" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">컨텐츠 {{locale.text}}</span>
        <ColorPicker class="mt5" :target="'contentsText'" :color="pointcolors.contentsText" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">공통 버튼1 {{locale.background}}</span>
        <ColorPicker class="mt5" :target="'defaultBtnBg'" :color="pointcolors.defaultBtnBg" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">공통 버튼1 {{locale.text}}</span>
        <ColorPicker class="mt5" :target="'defaultBtnText'" :color="pointcolors.defaultBtnText" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">공통 버튼2 {{locale.background}}</span>
        <ColorPicker class="mt5" :target="'defaultBtn2Bg'" :color="pointcolors.defaultBtn2Bg" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">공통 버튼2 {{locale.text}}</span>
        <ColorPicker class="mt5" :target="'defaultBtn2Text'" :color="pointcolors.defaultBtn2Text" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.alaram_count}} {{locale.background}}</span>
        <ColorPicker class="mt5" :target="'countBg'" :color="pointcolors.countBg" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.alaram_count}} {{locale.text}}</span>
        <ColorPicker class="mt5" :target="'countText'" :color="pointcolors.countText" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.product}} - {{locale.activate}}</span>
        <ColorPicker class="mt5" :target="'productActivate'" :color="pointcolors.productActivate" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.product}} - {{locale.cart}}</span>
        <ColorPicker class="mt5" :target="'productBtncart'" :color="pointcolors.productBtncart" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.amenity}} - {{locale.activate}}</span>
        <ColorPicker class="mt5" :target="'amenityActivate'" :color="pointcolors.amenityActivate" :pointcolors="true" />
      </div>
      <div class="flexInner">
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.amenity}} - {{locale.button}}</span>
        <ColorPicker class="mt5" :target="'amenityBtn'" :color="pointcolors.amenityBtn" :pointcolors="true" />
      </div>
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.amenity}} - {{locale.text}}</span>
        <ColorPicker class="mt5" :target="'amenityBtnText'" :color="pointcolors.amenityBtnText" :pointcolors="true" />
      </div>
    </div>
    <div class="flexBox mb15">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">{{locale.roomcontrol}} - {{locale.activate}}</span>
        <ColorPicker class="mt5" :target="'roomcontrolActivate'" :color="pointcolors.roomcontrolActivate" :pointcolors="true" />
      </div>
      <div class="flexInner">
      </div>
    </div>
    <div class="flexBox">
      <div class="flexInner">
        <span class="label toCapitalize colorGrey">로딩 - {{locale.background}}</span>
        <ColorPicker class="mt5" :target="'loadingBackground'" :color="pointcolors.loadingBackground" :pointcolors="true" />
      </div>
      <div class="flexInner">
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/Util/ColorPicker.vue'

export default {
  name: 'SetColors',
  props: [
    'locale',
    'pointcolors'
  ],
  components: {
    ColorPicker
  },
  computed: {
  }
}
</script>
